<div
  class="measurement-card block rounded-xl transition-shadow"
  [class.measurement-card--selectable]="selectable()"
  [class.measurement-card--selected]="selected()"
  [class.cursor-pointer]="selectable()"
  (click)="onClick()"
  (dblclick)="onDoubleClick()"
>
<p-card>
  <ng-template #title>{{ measurement().name }}</ng-template>
  <ng-template #subtitle>{{ 'measurement.types.' + measurement().measurementType | translate }}</ng-template>

  <div class="flex items-center gap-2 mb-3">
    <p-tag [severity]="statusSeverity()" [value]="('measurement.status.' + status()) | translate"></p-tag>
    @if (showLiveness()) {
      <cosmos-measurement-liveness-badge
        [measurementType]="measurementType()"
        [lastTimestamp]="lastTimestamp()"
      ></cosmos-measurement-liveness-badge>
    }
  </div>

  <div class="card-list-item">
    <div class="card-list-item-icon"><i class="fa-solid fa-ruler"></i></div>
    <div class="item-text">
      <div class="item-title">
        {{ lastTimestamp() ? (lastTimestamp() | date:'dd/MM/yyyy HH:mm:ss') : 'N/A' }}
      </div>
      <div class="item-line">{{ "cards.measurement.updated" | translate }}</div>
    </div>
  </div>

  @if (deviceName()) {
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-microchip"></i></div>
      <div class="item-text">
        <div class="item-title">{{ deviceName() }}</div>
        <div class="item-line">{{ "measurement.card.device" | translate }}</div>
      </div>
    </div>
  }

  @if (primaryValue() !== null && displayConfig(); as config) {
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-chart-line"></i></div>
      <div class="item-text">
        <div class="item-title">{{ primaryValue() | number:'1.0-2' }} {{ config.primaryUnit }}</div>
        <div class="item-line">{{ config.primaryLabel | translate }}</div>
      </div>
    </div>
  }

  <ng-template #footer>
    <div class="flex gap-4 mt-2" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
      <button pButton routerLink="/projects/{{ measurement().project }}/monitoring/measurement/{{ measurement()._id }}" class="w-1/3">{{ 'button.open' | translate }}</button>
    </div>
  </ng-template>
</p-card>
</div>
